export const MODAL_TOGGLE = 'MODAL_TOGGLE';



/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/